import api from '../api/api';

export const BOOKS_PER_PAGE = 25;

const pageCache = new Map();
const inflight = new Map();

export function booksCacheKey({ page = 1, q = '', filter = 'all' } = {}) {
  return `${filter}|${q || ''}|${page}`;
}

export function getBooksPageCache({ page = 1, q = '', filter = 'all' } = {}) {
  return pageCache.get(booksCacheKey({ page, q, filter })) || null;
}

export async function loadBooksPage(
  { page = 1, q = '', filter = 'all' } = {},
  { force = false } = {},
) {
  const key = booksCacheKey({ page, q, filter });

  if (!force && pageCache.has(key)) {
    return pageCache.get(key);
  }
  if (!force && inflight.has(key)) {
    return inflight.get(key);
  }

  const start = (page - 1) * BOOKS_PER_PAGE;
  const end = start + BOOKS_PER_PAGE;
  const params = { start, end };
  if (q) {
    params.q = q;
  }
  if (filter && filter !== 'all') {
    params.filter = filter;
  }

  const request = api
    .get('api/v1/pdf_parser/public_domain_books/', { params })
    .then(({ data }) => {
      const result = {
        books: data?.public_books || [],
        totalCount: data?.total_count ?? 0,
        page,
        q: q || '',
        filter: filter || 'all',
      };
      pageCache.set(key, result);
      inflight.delete(key);
      return result;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, request);
  return request;
}

export function clearBooksPageCache() {
  pageCache.clear();
  inflight.clear();
}
